import React from 'react';

const LiquidityComponent = () => {
  const liquidityImage="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Liquidity.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image side */}
          <div className="w-full md:w-2/5">
            <img 
              src={liquidityImage} 
              alt="Liquidity Portfolio" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">L: Liquidity – Readily Available When You Need It</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">Your Financial Cushion for Immediate Needs</h3>
            
            <p className="text-gray-700 mb-4">
              This bucket is your financial cushion. We allocate funds to liquid instruments like ultra-short debt funds or short-term FDs so that you always have easy access to money for emergencies, planned expenses or short-term needs.
            </p>
            
            <h4 className="font-medium text-[#113262] mb-2">Key liquidity instruments we use:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'Ultra-short term debt funds with high-quality portfolios',
                'Short-term fixed deposits with optimal interest rates',
                'Liquid mutual funds with minimal exit loads'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <h4 className="font-medium text-[#113262] mb-2">Why it matters:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'Avoids premature equity redemptions during market dips',
                'Provides peace of mind during financial uncertainties',
                'Keeps your long-term investment plan on track'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              Having sufficient <span className="font-bold">liquidity</span> is the foundation of any robust portfolio structure, ensuring you never need to compromise your long-term financial goals.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiquidityComponent;